export default __webpack_public_path__ + "static/media/008-jellyfish.dcfd3209.svg";